<template>
  <div class="container">
      <div class="left">
            {{this.$store.state.language.k}}<br/>
            <p style="margin-top:25px;font-size:1rem">{{this.$store.state.language.l}}</p>
      </div>
      <div class="right">
          <div class="imgBlock">
              <img :src="img" alt="OTA话务测试方案 5G test multi-UE 多UE自动化测试">
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
        img:'static/img/ota.jpg'
    };
  }
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  border-top: 1px solid white;
}
.left{
    width: 35%;
    height: 30rem;
    margin-left: 10%;
    margin-top: 3rem;
    float: left;
    font-size: 1.2rem;
}
.right{
    width: 35%;
    height: 30rem;
    margin-left: 15%;
    margin-top: 3rem;
    float: left;
    position: relative;
}
.imgBlock{
    width: 35rem;
    height: 25rem;
    background-color: gray;
    position: absolute;
    bottom: 0;
    right: 0
}
.imgBlock img{
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/application/ota.vue